import {
    Grid,
    Heading,
    HStack,
    Icon,
    Modal, ModalBody,
    ModalCloseButton, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, Text, useBreakpointValue, useDisclosure,
} from '@chakra-ui/react';
import { FaIcon, ServiceIcon } from '@acp/core-ui';
import { ServiceCode } from '@acp/shared';
import { useNavigate } from 'react-router-dom';
import { faInfoCircle } from '@fortawesome/sharp-light-svg-icons';
import { useGetStats } from '../../hooks/use-get-stats';
import { CardLayout } from '../card-layout';

export function ServicesBreakdownModal() {
    const navigate = useNavigate();
    const { onClose, onOpen, isOpen } = useDisclosure();
    const gridColumns = useBreakpointValue({
        base: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
    });
    const { isLoading, data } = useGetStats();

    if (isLoading || data === undefined) {
        return null;
    }

    const servicesBreakdown = data.portfolioStats.SERVICES_BREAKDOWN;

    const handleOnClickService = (service: string) => {
        const serviceMapping: Record<string, string> = {
            SMOKE: ServiceCode.SMOKE,
            GAS: ServiceCode.GAS,
            ELECTRICAL: ServiceCode.ELECTRICAL,
            CORDED_BLINDS: ServiceCode.CORDED_BLINDS,
            WATER_EFFICIENCY: 'water',
            RCD_SAFETY: 'rcd',
        };

        const serviceFilter = serviceMapping[service];

        onClose();
        navigate(`/portfolio?service=${serviceFilter}`, {
            replace: true,
        });
    };

    return (
        <>
            <FaIcon
                onClick={onOpen}
                icon={faInfoCircle}
                color="muted.500"
                pt={1}
                _hover={{ cursor: 'pointer' }}
            />

            <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
                <ModalOverlay />
                <ModalContent>

                    <ModalCloseButton />
                    <ModalHeader>
                        Services breakdown
                    </ModalHeader>

                    <ModalBody>
                        <Grid templateColumns={gridColumns} gap={3}>
                            {Object.entries(servicesBreakdown).map(([service, value]) => (
                                <CardLayout
                                    py={4}
                                    px={4}
                                    gap={2}
                                    borderWidth={1}
                                    h="full"
                                    onClick={() => handleOnClickService(service)}
                                    _hover={{ cursor: 'pointer', bg: 'muted.25' }}
                                    key={service}
                                    justifyContent="space-between"
                                >
                                    <CardLayout.Title>
                                        <HStack align="start">
                                            <Icon w={5} h={5} color="primary.500">
                                                <ServiceIcon service={service} />
                                            </Icon>
                                            <Text textTransform="capitalize">
                                                {service === 'SMOKE' ? 'Smoke Alarms' : service.replace('_', ' ').toLowerCase()}
                                            </Text>
                                        </HStack>
                                    </CardLayout.Title>
                                    <CardLayout.Body align="start">
                                        <Heading variant="circular" fontWeight="500" fontSize="x-large">
                                            {value.toLocaleString()}
                                        </Heading>
                                    </CardLayout.Body>
                                </CardLayout>
                            ))}
                        </Grid>
                    </ModalBody>
                    <ModalFooter />
                </ModalContent>
            </Modal>
        </>
    );
}
